var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"height":`${_vm.height}px` || '16px',"width":`${_vm.width}px` || '21px',"viewBox":"0 0 21 16"}},[_c('path',{attrs:{"d":"M11.8779 16V0L20.4865 8L11.8779 16Z","fill":_vm.color}}),_c('path',{attrs:{"d":"M13.8344 5.57578H0.138992V10.4243H13.8344V5.57578Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }